import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const BUCKET = 'sapot-mobile-apk';

export function useApkRelease() {
  const [apkUrl, setApkUrl] = useState(null);

  useEffect(() => {
    if (!supabase) return;
    async function fetchLatest() {
      const { data, error } = await supabase.storage
        .from(BUCKET)
        .list('', { sortBy: { column: 'created_at', order: 'desc' } });

      if (error || !data?.length) return;

      const latest = data[0];
      const { data: urlData } = supabase.storage
        .from(BUCKET)
        .getPublicUrl(latest.name);

      setApkUrl(urlData.publicUrl);
    }
    fetchLatest();
  }, []);

  return { apkUrl };
}
